import { useMutation } from '@apollo/client';
import { APPRAISER_EVENT_STAGE } from '../constants/AppraiserEventStage';
import SAVE_ASSIGNMENT_ACTION from '../queries/saveAssignmentActionMutation';
import { useNavigate } from 'react-router-dom';
import { showSuccessToast } from '@shared/services/toastService';
import { EVENT_APPRAISER_ASSIGNMENT_STATUS } from '../components/shared/constants';

const previousLink = '/calendar';

const useSaveAssignmentAction = (eventIdParsed, event) => {
  const navigate = useNavigate();

  const [saveAssignmentAction, { error: saveAssignmentActionError }] =
    useMutation(SAVE_ASSIGNMENT_ACTION);

  const handleSubmitAssignmentAction = async assignmentData => {
    const status = assignmentData.Status;
    const actionMessage =
      status === EVENT_APPRAISER_ASSIGNMENT_STATUS.ACCEPTED ? 'accepted' : 'rejected';

    await saveAssignmentAction({
      variables: {
        assignmentData: { ...assignmentData, EventId: eventIdParsed }
      }
    });

    showSuccessToast(`Assignment ${actionMessage} successfully.`);

    if (
      status === EVENT_APPRAISER_ASSIGNMENT_STATUS.REJECTED &&
      event?.Stage >= APPRAISER_EVENT_STAGE.TEAM_ASSIGNED
    ) {
      navigate(previousLink);
    }
  };

  return {
    handleSubmitAssignmentAction,
    error: saveAssignmentActionError
  };
};

export default useSaveAssignmentAction;
